import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import PromiseWithCancel from '../../../remote-request/promise-with-cancel'
import { fetchWithRetry } from '../../../authorisation'

import DisplayAssetView from './views'
import { apiFromPath } from './helpers'

export class DisplayAsset extends Component {
  constructor(props) {
    super(props)
    this.state = {
      data: null,
      loading: true,
      error: null,
    }
    this.submitRequest(props)
  }

  formatResponse(response) {
    try {
      const jsonObject = JSON.parse(response)
      if (jsonObject && typeof jsonObject === 'object') return jsonObject
    } catch (e) {
      return response
    }
  }

  setErrorState() {
    this.setState({
      loading: false,
      error: 'No attachment found',
    })
  }

  submitRequest({ testFetch, path, jwt, token, dispatchAction }) {
    if (process.env.NODE_ENV === 'test' || testFetch) return

    const request = PromiseWithCancel(
      fetchWithRetry(
        apiFromPath(path),
        {
          token: jwt || token,
          method: 'GET',
          mimeType: 'text/html',
        },
        dispatchAction
      )
    )

    request.promise
      .then(response =>
        response.text().then(payload => {
          const formatedPayload = this.formatResponse(payload)

          formatedPayload.errors
            ? this.setErrorState()
            : this.setState({
              loading: false,
              data: formatedPayload,
            })
        })
      )
      .catch(() => this.setErrorState())
  }

  render() {
    return <DisplayAssetView {...this.state} />
  }
}

const mapDispatchToProps = dispatch => ({
  dispatchAction: action => dispatch(action),
})

const mapStateToProps = state => ({
  jwt: state.authorisation.jwt,
})

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(DisplayAsset)
)



// WEBPACK FOOTER //
// ./src/ui/gov-messages/display-asset/container.js